<template>
  <div :class="getItemTableContainerClass">
    <ItemTable
      ref="itemTable"
      :columns="columns"
      :emptyCollectionMessage="emptyCollectionMessage"
      :inDetailsAsidePanel="inDetailsAsidePanel"
      :isAsideOpen="true"
      :itemType="itemType"
      placeholderText="Search by device name"
      :selectionItemText="statusItemText"
      :showBound="false"
      :showSearchForm="true"
      :showSelectedItemsCount="false"
      :useDropDownFilterComponent="filterComponents.PolicySystemStatusDropDownFilter"
      :useSearchContextFilterComponent="filterComponents.PolicySystemStatusSearchFilter"
    />
  </div>
</template>

<script>
import * as Constants from 'client/util/Constants';
import { mapActions, mapGetters } from 'vuex';
import { notify } from 'client/util';
import ItemTable from 'client/components/ItemTable/ItemTable.vue';
import ItemTableComputedMixin from 'client/components/ItemTable/mixins/ItemTableComputedMixin';
import ItemTablePropsMixin from 'client/components/ItemTable/mixins/ItemTablePropsMixin';
import ModalEventBus from 'components/Modal/ModalEventBus';
import PolicyStatusModal from 'client/policies/views/PolicyStatusModal.vue';
import PolicySystemStatusApi from 'client/api/v2/PolicySystemStatusApi';
import _ from 'lodash';

const {
  BodyComponentConsts,
  ItemTableConsts,
  ItemTypeConsts,
  FilterComponentConsts,
  StoreModuleMap,
} = Constants;

const { columnTypes } = ItemTableConsts;

const { error } = Constants.default;

const storeModule = StoreModuleMap[ItemTypeConsts.policyStatus];

export default {
  name: 'PolicySystemStatusItemTable',

  components: {
    ItemTable,
  },

  mixins: [
    ItemTableComputedMixin,
    ItemTablePropsMixin,
  ],

  props: {
    policyId: {
      type: String,
      required: true,
    },
  },

  data() {
    const columns = [
      {
        bodyComponent: 'StatusIcon',
        bodyComponentProps: {
          type: BodyComponentConsts.statusIconTypes.policyStatus,
        },
        classNames: {
          body: [columnTypes.statusColumn],
          heading: [columnTypes.statusColumn],
        },
        headingText: 'Status',
      }, {
        bodyComponent: 'ItemName',
        bodyComponentProps: {
          indirectItem: ItemTypeConsts.system,
          itemType: ItemTypeConsts.device,
          titleField: 'system.displayName',
          subtitleField: 'system.amazonInstanceID',
        },
        headingText: 'System Name',
      }, {
        bodyComponent: 'SystemOSIcon',
        classNames: {
          body: [columnTypes.osColumn, 'policyStatusOsColumn'],
          heading: [columnTypes.osColumn, 'policyStatusOsColumn'],
        },
        headingText: 'OS',
      }, {
        bodyComponent: 'ViewDetailsButton',
        bodyComponentProps: {
          handleClick: this.createModal,
        },
        classNames: {
          body: ['viewResultsButtonColumn'],
          heading: ['viewResultsButtonColumn'],
        },
      },
    ];

    const statusItemText = {
      label: 'bound',
      plural: 'statuses',
      singular: 'status',
    };

    return {
      columns,
      itemType: ItemTypeConsts.policyStatus,
      filterComponents: FilterComponentConsts,
      statusItemText,
    };
  },

  beforeCreate() {
    _.extend(
      this.$options.computed,
      mapGetters(storeModule, {
        totalCountOfAllItems: 'getTotalCountOfAllItems',
      }),
    );
  },

  created() {
    this.setPolicyId(this.policyId);
  },

  methods: {
    ...mapActions(storeModule, [
      'setPolicyId',
    ]),

    async createModal(item) {
      const { systemID, policyID } = item;
      try {
        const response = await PolicySystemStatusApi.getDetails(systemID, policyID);
        ModalEventBus.open({
          component: PolicyStatusModal,
          componentProps: {
            policyStatus: item,
            groupNames: response.join(', '),
          },
          isLargeModal: true,
        });
      } catch (err) {
        notify(error, err);
      }
    },
  },
};
</script>
